'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const tryGet=require('pulsar-utils/dist-es6/extensions/tryGet');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const ControllerExtensions=require('../../../../dist-es6/client/extensions/controllerExtensions');
const{HandleUncaughtErrors}=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations;
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const moment=require('pulsar-utils/dist-es6/time/moment');

const _subViewLabelsByType={
incidents:'Incidents',
trends:'Fatigue Trends'};let


FleetInsightController=(_class=class FleetInsightController extends BaseController{
static get $inject(){
return[
'$timeout',
'$state',
'$scope',
'$element',
'breadcrumbsService',
'intervalService',
'fatigueTrendsDataService',
'fleetIncidentsDataService',
'uncaughtErrorHandler',
'groupTreeService',
'fatigueMeterTypeContentProviderService'];

}

constructor($timeout,$state,$scope,$element,breadcrumbsService,intervalService,fatigueTrendsDataService,fleetIncidentsDataService,uncaughtErrorHandler,groupTreeService,fatigueMeterTypeContentProviderService){
super(uncaughtErrorHandler);

this._$timeout=$timeout;
this._$state=$state;
this._$scope=$scope;
this._intervalService=intervalService;
this._fatigueTrendsDataService=fatigueTrendsDataService;
this._fleetIncidentsDataService=fleetIncidentsDataService;
this._groupTreeService=groupTreeService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;

this._redirectPending=!1;
this._displayInterval=void 0;
this._currentServiceForSubView=void 0;

breadcrumbsService.startTrail(this._fatigueMeterTypeContentProviderService.fleetInsightPageTitle);
this.fatigueMeterType=this._fatigueMeterTypeContentProviderService.fatigueMeterType;

this._safeWatch('multiView',()=>{
if(this._redirectPending){
this._redirectToFatigueTrends();
}
});
this._safeWatch('selectedView',()=>this._onSelectedViewChanged());
this._safeWatch('displayInterval',()=>this._updateCurrentServiceIfStale());
}

_onSelectedViewChanged(){
const serviceForSubView=this.selectedView.label===_subViewLabelsByType.incidents?
this._fleetIncidentsDataService:
this._fatigueTrendsDataService;

if(_.exists(this._currentServiceForSubView)&&serviceForSubView===this._currentServiceForSubView){
return;
}

this._currentServiceForSubView=serviceForSubView;

if(!_.exists(this._displayInterval)){
const displayIntervalFromParams=_tryGetDisplayIntervalFromQueryParam(this._$state.params.interval);
this.displayInterval=displayIntervalFromParams||
this._currentServiceForSubView.displayInterval||
this._intervalService.previousFourWeeksAndWeekToDateForDisplay;
}else{
this._updateCurrentServiceIfStale();
}
}

_updateCurrentServiceIfStale(){
if(!_.exists(this._currentServiceForSubView)||
_.exists(this._currentServiceForSubView.groupTree)&&
this._displayInterval.equals(this._currentServiceForSubView.displayInterval)){
return;
}


this._currentServiceForSubView.displayInterval=this._displayInterval;
this._startUpdate();
}

get subViewLabelsByType(){
return _subViewLabelsByType;
}

get displayInterval(){
return this._displayInterval;
}

set displayInterval(displayInterval){
this._displayInterval=displayInterval;

if(_.exists(displayInterval)){
this._$state.go('fdc.features.fleetInsight',{
interval:`${_dateForIntervalQueryParam(displayInterval.start)}to${_dateForIntervalQueryParam(displayInterval.end)}`});

}
}

get redirectResolved(){
return this._fleetIncidentsDataService.redirectResolved;
}


async _startUpdate(){
await this._currentServiceForSubView.update();
if(this.redirectResolved){
return;
}
this._$timeout(()=>{
if(_.get(this._fleetIncidentsDataService,'incidentTypes.length')===0){
this._redirectPending=!0;
if(_.exists(this.multiView)){
this._redirectToFatigueTrends();
}
}else{
this._fleetIncidentsDataService.redirectResolved=!0;
}
});
}

_redirectToFatigueTrends(){
this._redirectPending=!1;
this.multiView.selectViewAtIndex(1);
this._fleetIncidentsDataService.redirectResolved=!0;
}

get dataService(){
return this._fatigueTrendsDataService;
}

get selectedGroup(){

return this._groupTreeService.selectedGroup;
}

get fatigueTrendsAggregateData(){
if(this._currentServiceForSubView===this._fatigueTrendsDataService){
return this._fatigueTrendsDataService.selectedGroupData;
}

return null;
}

get showLoadingSpinner(){
return!_.exists(this._currentServiceForSubView)||this._currentServiceForSubView.isUpdating;
}},(_applyDecoratedDescriptor(_class.prototype,'_startUpdate',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_startUpdate'),_class.prototype)),_class);


function _tryGetDisplayIntervalFromQueryParam(interval){
try{
let split=interval.split('to');

let start=new Date(moment(split[0]));
let end=new Date(moment(split[1]));
if(Number.isNaN(+start)||Number.isNaN(+end)){
return null;
}
let endForDisplay=moment(end).endOf('day');
return TimeInterval.from(start).to(endForDisplay);
}catch(e){

return null;
}
}

function _dateForIntervalQueryParam(date){
return moment(date).format('YYYY-MM-DD');
}

module.exports=FleetInsightController;
//# sourceMappingURL=fleetInsightController.js.map
